/// <amd-module name="Dashboards/ConfigHost/WideConfigPanelPolicy" />

import { WidgetCatalogEntry } from "Dashboards/WidgetContracts/Internal/WidgetCatalogEntry";
import { widgetConfigUsesWideFormat } from "Dashboards/WidgetContractServices/WideConfigPanelPolicy";

// Everything here is hard-coded policy directly ported from legacy. Going forward, we should ratify a 3rd-party friendly public contract for panel size customization.

export function getPanelWidth(catalogEntry: WidgetCatalogEntry | undefined): string {
    const defaultPanelClass = "default-widget-config-panel-width";
    const widePanelClass = "wide-widget-config-panel-width";

    return catalogEntry && widgetConfigUsesWideFormat(catalogEntry.contributionId) ? widePanelClass : defaultPanelClass;
}
